import React from 'react';
import { motion } from 'framer-motion';
import { BarChart3Icon, EyeIcon, InfinityIcon, RocketIcon } from 'lucide-react';
import { toast } from 'sonner';
import { Sheet } from './ui/Sheet';
import { Button } from './ui/Button';
import { useMarketplace } from '../contexts/MarketplaceContext';
import { stagger, rise } from '../utils/motion';
interface ProSheetProps {
  open: boolean;
  onClose: () => void;
  reason?: string;
}
const perks = [{
  icon: EyeIcon,
  title: 'See who liked you',
  body: 'Organisers who swiped right on you show up as invites — match instantly.'
}, {
  icon: InfinityIcon,
  title: 'Unlimited applications',
  body: 'Free accounts get 10 a week. Pro has no cap.'
}, {
  icon: RocketIcon,
  title: 'One boost a week',
  body: 'Jump to the top of organisers’ decks for 24 hours.'
}, {
  icon: BarChart3Icon,
  title: 'Profile insights',
  body: 'See views, saves and which songs get played most.'
}];
export function ProSheet({
  open,
  onClose,
  reason
}: ProSheetProps) {
  const {
    setPro
  } = useMarketplace();
  return <Sheet open={open} onClose={onClose} title="Encorza Pro" footer={<div data-id="element-673" data-mp="3isv3kso8m0x3">
          <Button variant="accent" size="lg" fullWidth onClick={() => {
      setPro(true);
      toast.success('You’re Pro now', {
        description: 'Hidden likes are unlocked in Gigs → Invites.'
      });
      onClose();
    }} data-id="element-674" data-mp="3isbkh8mup6hh">
            Start Pro · ฿299/month
          </Button>
          <p className="mt-3 text-center text-[13px] text-ink-3" data-id="element-675" data-mp="2zwlivmityc44">Cancel anytime. Performers never pay booking fees.</p>
        </div>} data-id="element-672" data-mp="3esb3bg8dah6q">
      {reason && <p className="mb-5 rounded-sm bg-tint px-4 py-3 text-[15px] font-semibold text-brand-strong" data-id="element-676" data-mp="39tq67poewdmi">{reason}</p>}
      <p className="text-[17px] leading-relaxed text-ink-2" data-id="element-677" data-mp="k4o2kmda1aol">Get booked faster. Pro puts you in front of more organisers and shows you who already wants you.</p>
      <motion.ul variants={stagger} initial="hidden" animate="show" className="mt-6 divide-y divide-line" data-id="element-678" data-mp="p1o36hrcxl8b">
        {perks.map(({
        icon: Icon,
        title,
        body
      }) => <motion.li key={title} variants={rise} className="flex gap-4 py-4" data-id="element-679" data-mp="3qkmqs428t6xo">
            <span className="grid h-11 w-11 shrink-0 place-items-center rounded-sm bg-surface-2 text-ink" data-id="element-680" data-mp="9e2owmwqn9cr">
              <Icon className="h-5 w-5" data-id="element-681" data-mp="4e6kimk4pfwo" />
            </span>
            <span data-id="element-682" data-mp="4clsb3lae91z">
              <span className="block font-bold" data-id="element-683" data-mp="3cu01f2idgte9">{title}</span>
              <span className="mt-0.5 block text-sm leading-relaxed text-ink-2" data-id="element-684" data-mp="3cujcbz9luhis">{body}</span>
            </span>
          </motion.li>)}
      </motion.ul>
    </Sheet>;
}